import { render, staticRenderFns } from "./AboutUsHomepage.vue?vue&type=template&id=06a61a0d&"
import script from "./AboutUsHomepage.vue?vue&type=script&lang=js&"
export * from "./AboutUsHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports